window.ApiServer = 'http://api-kpp.if.iqiyi.com/api'
window.imageDefaultUrl = 'http://pic0.iqiyipic.com/common/20190929/cb0b8a913d0d4ea89dde9e4873df124f.png'
export const VISIBILITY_FILTERS = {
    ALL: "all",
    COMPLETED: "completed",
    INCOMPLETE: "incomplete"
}



// WEBPACK FOOTER //
// ./src/common/constants/index.js